import {
  observable,
  action
} from 'mobx'
export default class fwMobileHome {
  @observable showUser = false;
  @observable showUserShareList = false;
  @observable notAnnot = false;
  @observable notModify = false;
  @observable notExtract = false;
  @observable User_Permissions = {
    /**
     * Print PDF document with normal mode. (Bit 3 in permission value)
     */
    print: 0b100,
    /**
     * Modify PDF contents. (Bit 4 in permission value)\n
     * If this value is set, user can modify contents of PDF document by operations other than those controlled by values User_Permissions::annotForm, User_Permissions::fillForm and User_Permissions::assemble.
     */
    modify: 0b1000,
    /**
     * Extract PDF contents. (Bit 5 in permission value)\n
     * If this value is set, user can copy or otherwise extract text and graphics from the document by operations other than that controlled by value User_Permissions::extractAccess.
     */
    extract: 0b10000,
    /**
     * Operate text annotations and fill in interactive form fields. (Bit 6 in permission value)\n
     * If value User_Permissions::modify is also set, user can create or modify interactive form fields (including signature fields).
     */
    annotForm: 0b100000,
    /**
     * Fill PDF form. (Bit 9 in permission value)\n
     * If this value is set, user can fill in interactive form fields (including signature fields), even if value User_Permissions::annotForm is not used.
     */
    fillForm: 0b100000000,
    /**
     * Disabilities support. (Bit 10 in permission value)\n
     * If this value is set, user can extract text and graphics in support of accessibility to users with disabilities or for other purposes.
     */
    extractAccess: 0b1000000000,
    /**
     * Assemble PDF document. (Bit 11 in permission value)\n
     * If this value is set, it enables to assemble the document (Insert, rotate, or delete pages and create bookmarks or thumbnail images), regardless if value User_Permissions::modify is set or not.
     */
    assemble: 0b10000000000,
    /**
     * Print PDF document with higher qualities. (Bit 12 in permission value)\n
     * If this value is not set (and value User_Permissions::print is set), printing is limited to a low-level representation of the appearance, possibly of degraded quality.
     */
    printHigh: 0b100000000000,
};
  

  @action setShowUser(val) {
    this.showUser = val
  }
  
  @action setShowUserShareList(val) {
    this.showUserShareList = val
  }

  @action async getCompHandle(comp) {
    let compByName = await window.pdfui.getComponentByName(comp)
    console.log(comp)
    console.log(compByName)
    if(compByName) {
      compByName.controller.handle()
      return Promise.resolve()
    } else {
      return Promise.reject()
    }
  }

  @action permissionCheck (key) {
    return new Promise(resolve => {
      pdfui.getCurrentPDFDoc().then(pdfDoc => {
        console.log("checkPermission")
        console.log(key)
        console.log(!pdfDoc.checkPermission(this.User_Permissions[key]))
        if(!pdfDoc.checkPermission(this.User_Permissions[key])) {
          resolve(false)
        }
        resolve(true)
      })
    })
  }
  @action getAllPermission () {
    this.permissionCheck("annotForm").then(hasPermission => {
      this.notAnnot = !hasPermission;
    })
    this.permissionCheck("modify").then(hasPermission => {
      this.notModify = !hasPermission;
    })
    this.permissionCheck("extract").then(hasPermission => {
      this.notExtract = !hasPermission;
    })
  }
 
  @action colorConvertor(color, outType = 'HTML',opacity = 1){
      var value = '';
      var R, G, B;
      let components;
      if(color>0xFFFFFFFF){
          throw new Error('Incorrect color');
      }

      if(typeof color == 'number'){
          color = ['int',color];
      }
    switch (color[0]) {
      case 'int':
      R = (color[1]&0x00ff0000)>>16;
      G = (color[1]&0x0000ff00)>>8;
      B = (color[1]&0x000000ff);
      break;
      case 'T':
        R = 0;
        G = 0;
              B = 0;
              opacity=0;
        break;
      case 'G':
        R = G = B = color[1] * 255;
        break;
      case 'RGB':
        R = color[1] * 255;
        G = color[2] * 255;
        B = color[3] * 255;
        break;
      case 'CMYK':
        R = ((1 - color[4]) * (1 - color[1])) * 255;
        G = ((1 - color[4]) * (1 - color[2])) * 255;
        B = ((1 - color[4]) * (1 - color[3])) * 255;
              break;
          case 'r':
              components = color.match(/rgba?\((\d*),\s*(\d*),\s*(\d*),?\s*([\.0-9]*)?\)/);
              R=+components[1];
              G=+components[2];
              B=+components[3];
              let _opacity = components[4];
              if (typeof _opacity !== 'undefined') {
                  opacity = +_opacity;
              }
              break;
          case '#':
              let p = color.length==4?/#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/:/#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
              components = color.match(p);
              R=parseInt(components[1],16);
              G=parseInt(components[2],16);
              B=parseInt(components[3],16);
              break;
          default:
              throw new Error('Unsupported color format');
    }
    switch(outType){
      case 'HTML':
        if (R === G && G === B && B === -1) { value = 'transparent' }
        else {
          value = 'rgba(' + parseInt(R) + ',' + parseInt(G) + ',' + parseInt(B) + ','+opacity+')';
        }
          break;
          case 'RGB':
                  value=['RGB',R/255,G/255,B/255];
        break;
          case '#':
              if(R<16){
                  value +='#0'+R.toString(16);
              }else{
                  value +='#'+R.toString(16);
              }
              if(G<16){
                  value +='0'+G.toString(16);
              }else{
                  value +=G.toString(16);
              }
              if(B<16){
                  value +='0'+B.toString(16);
              }else{
                  value +=B.toString(16);
              }
          break;
      case 'int':
        value = 0;

        opacity*=255;
        value |= opacity<<24;
        value |= R<<16;
        value |= G<<8;
        value |= B;
        value = value>>>0
      break;
          case 'CMYK':{

              let C = 255 - R;
              let M = 255 - G;
              let Y = 255 - B;
              let K = Math.min(C,M,Y);

                  return ['CMYK',C/255,M/255,Y/255,K/255]
          }
          case 'GRAY':{
              return ['GRAY',(0.3*R+0.59*G+0.11*B)/255]
          }
    }
    

    return value;
  }
}
